export default [
  {
    path: '/admin/asr',
    name: 'asr',
    component: () => import('@/views/admin/asr/asr.vue'),
    meta: { title: 'ASR', requireAuth: true }
  }
]
